export { GeneralMessage } from './GeneralMessage';
export { type GeneralMessageProps } from './GeneralMessage.types';
